"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var csod = require("player-core");
function viewSL() {
    var updatePostedDateAriaLabel = function () {
        setTimeout(function () {
            var postedDateElement = document.querySelector('[data-tag="postingDates"]');
            if (postedDateElement && postedDateElement.textContent) {
                var text = postedDateElement.textContent;
                var cultureName_1 = (csod.viewModel && csod.viewModel.siteSettings && csod.viewModel.siteSettings.currentLanguageDetail)
                    ? csod.viewModel.siteSettings.currentLanguageDetail.cultureName
                    : (csod.context.cultureName || 'en-US');
                cultureName_1 = cultureName_1.replace(/_/g, '-');
                var ariaText = text;
                ariaText = ariaText.replace(/(\d{4})-(\d{1,2})-(\d{1,2})/g, function (match, year, month, day) {
                    return formatDate(parseInt(year, 10), parseInt(month, 10) - 1, parseInt(day, 10));
                });
                ariaText = ariaText.replace(/(\d{4})\/(\d{1,2})\/(\d{1,2})/g, function (match, year, month, day) {
                    return formatDate(parseInt(year, 10), parseInt(month, 10) - 1, parseInt(day, 10));
                });
                ariaText = ariaText.replace(/(\d{4})\.\s*(\d{1,2})\.\s*(\d{1,2})\./g, function (match, year, month, day) {
                    return formatDate(parseInt(year, 10), parseInt(month, 10) - 1, parseInt(day, 10));
                });
                ariaText = ariaText.replace(/(\d{1,2})\/(\d{1,2})\/(\d{4})/g, function (match, first, second, year) {
                    var firstNum = parseInt(first, 10);
                    var secondNum = parseInt(second, 10);
                    var day, month;
                    var mmddyyyyCultures = ['en-US', 'en-CA'];
                    var usesMMDDYYYY = mmddyyyyCultures.some(function (c) { return cultureName_1.startsWith(c); });
                    if (usesMMDDYYYY) {
                        month = firstNum - 1;
                        day = secondNum;
                    }
                    else {
                        day = firstNum;
                        month = secondNum - 1;
                    }
                    return formatDate(parseInt(year, 10), month, day);
                });
                postedDateElement.setAttribute('aria-label', ariaText);
                postedDateElement.setAttribute('role', 'text');
                var childNodes = postedDateElement.querySelectorAll('*');
                for (var i = 0; i < childNodes.length; i++) {
                    childNodes[i].setAttribute('aria-hidden', 'true');
                }
                if (postedDateElement.childNodes.length > 0) {
                    Array.from(postedDateElement.childNodes).forEach(function (node) {
                        if (node.nodeType === Node.TEXT_NODE && node.textContent.trim()) {
                            var span = document.createElement('span');
                            span.setAttribute('aria-hidden', 'true');
                            span.textContent = node.textContent;
                            postedDateElement.replaceChild(span, node);
                        }
                    });
                }
            }
        }, 100);
    };
    var formatDate = function (year, month, day) {
        var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        if (month >= 0 && month < 12) {
            return day + " " + months[month] + " " + year;
        }
        return day + "/" + (month + 1) + "/" + year;
    };
    return {
        constructor: function (props) {
        },
        mounted: function () {
            updatePostedDateAriaLabel();
        },
        didUpdate: function () {
            updatePostedDateAriaLabel();
        },
        events: {
            onApplyClick: this.props.onApplyClick,
            onSaveClick: this.props.onSaveClick,
            onShareClick: this.props.onShareClick,
            setContentHeight: this.props.setContentHeight
        }
    };
}
exports.viewSL = viewSL;



//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-career-site/src/.tmp/JobDetailsBannerContent/ViewSL.js
// module id = 969
// module chunks = 0